import { useCallback, useRef } from "react";

import { swSettings } from "app/common/services/swSettings";
import { useHDBannerCta } from "app/marketing/components/common/banners/HDBanner/useHDBannerCta";
import WWOTrafficVisitsOverTime from "app/pages/website-performance/components/TrafficVisitsOverTime/WWOTrafficVisitsOverTime";
import { getHooksVersion } from "app/UtilitiesAndConstants/UtilityFunctions/hooksUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTrafficVisitsOverTimeContainerDS = () => {
    const getCtaLink = (params) => {
        return {
            href: proNavigator.href("digitalsuite_website_trafficandengagement", params),
            target: "_self",
        };
    };

    const hdBannerCtaState = useHDBannerCta({
        trackingName: "Graph tooltip/visits over time",
    });
    /*
     * The add-on availability arrives after the chart config is built, and the tooltip formatter lives
     * on in that config, so the banner state is read when the tooltip opens rather than closed over
     */
    const hdBannerCtaStateRef = useRef(hdBannerCtaState);
    hdBannerCtaStateRef.current = hdBannerCtaState;
    const getHdBannerCtaState = useCallback(() => hdBannerCtaStateRef.current, []);

    return (
        <WWOTrafficVisitsOverTime
            getCtaLink={getCtaLink}
            getHdBannerCtaState={getHdBannerCtaState}
            unlockHook={{
                component: "WsWebTrafficAndEngagement",
                hookModal: "trafficAndEngagement",
                version: getHooksVersion(swSettings),
                overrideTrackingKey: "TrafficOverTime",
            }}
        />
    );
};
